const setFrame = (frame, mat) => {
  const frameWrapper = document.getElementById("frame-visual");
  if (!frameWrapper) return;

  // Targets to be manipulated:
  const frameWidthLine = document.getElementById("frame-width-line");
  const frameHeightLine = document.getElementById("frame-height-line");
  const matWidthLine = document.getElementById("mat-width-line");
  const matHeightLine = document.getElementById("mat-height-line");
  const exteriorFrameBox = document.getElementById("frame-box-outer");
  const interiorFrameBox = document.getElementById("frame-box-inner");
  const matBox = document.getElementById("mat-box");

  // frame and mat will be a string "5x7", destructure into width/height values:
  const [fwidth, fheight] = frame.split("x").map((num) => Number(num));
  const [mwidth, mheight] = mat.split("x").map((num) => Number(num));

  const _mouldingWidth = 1;
  const _coefficient = 13;

  matBox.style.width = (mwidth * _coefficient).toString() + "px";
  matBox.style.height = (mheight * _coefficient).toString() + "px";

  interiorFrameBox.style.width = (fwidth * _coefficient).toString() + "px";
  interiorFrameBox.style.height = (fheight * _coefficient).toString() + "px";

  exteriorFrameBox.style.width =
    ((fwidth + _mouldingWidth * 2) * _coefficient).toString() + "px";
  exteriorFrameBox.style.height =
    ((fheight + _mouldingWidth * 2) * _coefficient).toString() + "px";

  frameWidthLine.style.width = (fwidth * _coefficient).toString() + "px";
  frameWidthLine.style.marginLeft =
    (_mouldingWidth * _coefficient).toString() + "px";
  frameHeightLine.style.height = (fheight * _coefficient).toString() + "px";
  frameHeightLine.style.marginTop =
    (_mouldingWidth * _coefficient).toString() + "px";

  matWidthLine.style.width = (mwidth * _coefficient).toString() + "px";
  matHeightLine.style.height = (mheight * _coefficient).toString() + "px";
};

const clearPreviousActive = () => {
  const activeRows = document.querySelectorAll(".active-row");
  const activeMats = document.querySelectorAll(".active-mat");

  if (activeRows) {
    activeRows.forEach((row) => row.classList.remove("active-row"));
  }
  if (activeMats) {
    activeMats.forEach((item) => item.classList.remove("active-mat"));
  }
};

const setActive = (target) => {
  clearPreviousActive();
  target.parentNode.classList.add("active-row");
  target.classList.add("active-mat");
};

// NEW: Toggle wall vs diploma table + auto-select first clickable size
const showSizeGuide = (type) => {
  const wall = document.getElementById("size-guide-table-wall");
  const diploma = document.getElementById("size-guide-table-diploma");
  if (!wall || !diploma) return;

  const isDiploma = type === "diploma";
  wall.classList.toggle("size-guide-hidden", isDiploma);
  diploma.classList.toggle("size-guide-hidden", !isDiploma);

  // Clear any previous active state when switching tables
  clearPreviousActive();

  // Auto-select first clickable cell in the active table (if visual exists)
  const activeTable = isDiploma ? diploma : wall;
  const firstClickable = activeTable.querySelector(
    "td[data-frame-size][data-mat-size]",
  );

  if (firstClickable) {
    setFrame(
      firstClickable.getAttribute("data-frame-size"),
      firstClickable.getAttribute("data-mat-size"),
    );
    setActive(firstClickable);
  }
};

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const toggles = document.querySelectorAll(".size-guide-toggle");

    const params = new URLSearchParams(window.location.search);
    const initialType = params.get("frame") === "diploma" ? "diploma" : "wall";

    const setActiveToggle = (type) => {
      toggles.forEach((btn) => {
        btn.classList.toggle(
          "active",
          btn.getAttribute("data-frame-type") === type,
        );
      });
    };

    toggles.forEach((btn) => {
      btn.addEventListener("click", () => {
        const type = btn.getAttribute("data-frame-type");

        showSizeGuide(type);
        setActiveToggle(type);

        // Update URL without reload
        const url = new URL(window.location.href);
        url.searchParams.set("frame", type);
        window.history.replaceState({}, "", url.toString());
      });
    });

    showSizeGuide(initialType);
    setActiveToggle(initialType);
  },
  false,
);
